export default function showTooltip ({content = undefined}) {
  return {
    type: 'SHOW_TOOLTIP',
    payload: {content},
  };
}




// WEBPACK FOOTER //
// ./lib/rlink-tooltips/actions/showTooltip.js